import React, { forwardRef } from "react";
import { Chip } from "@material-ui/core";
import { WarningOutlined } from "@material-ui/icons";

const chipStyle = {
	color: "#ff9800",
	marginLeft: 8,
	border: "1px solid #ff9800",
	padding: "0 4px",
	maxWidth: "150px",
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
};

const WarningChip = forwardRef(({ label, icon, ...props }, ref) => {
	return (
		<Chip
			ref={ref}
			icon={
				icon || (
					<WarningOutlined style={{ color: chipStyle.color, width: "14px" }} />
				)
			}
			label={label}
			size="small"
			style={chipStyle}
			variant="outlined"
			{...props}
		/>
	);
});

export default WarningChip;
